module.exports = __webpack_public_path__ + "img/telefono.23f59925.png";